import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const next = params.get('next') || '/dashboard';
  const navigate = useNavigate();
  const { loading, session } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (session) {
      navigate(next, { replace: true });
    } else {
      // Auth helper didn't pick up the session. Bounce back to login.
      navigate('/login', { replace: true });
    }
  }, [loading, session, next, navigate]);

  return (
    <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', color: 'var(--ink-soft)' }}>
      <span className="mono" style={{ fontSize: 13, letterSpacing: '0.14em', textTransform: 'uppercase' }}>
        Signing you in…
      </span>
    </div>
  );
}
